import { render, staticRenderFns } from "./FormColumns.vue?vue&type=template&id=0597f816"
import script from "./FormColumns.vue?vue&type=script&lang=js"
export * from "./FormColumns.vue?vue&type=script&lang=js"
import style0 from "./FormColumns.vue?vue&type=style&index=0&id=0597f816&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports